import React, { createContext, useContext, useMemo } from "react";

type ContextValue = {
  user?: CurrentUser;
};

export type CurrentUser = {
  name: string;
  isSuperUser: boolean;
  isAdmin: boolean;
  isSigner: boolean;
  isSikringOnly: boolean;
};

const CurrentUserContext = createContext<ContextValue | undefined>(undefined);

export function CurrentUserProvider({ user, children }: { user?: CurrentUser; children: React.ReactNode }) {
  const value = useMemo(() => {
    return { user };
  }, [user]);

  return <CurrentUserContext.Provider value={value}>{children}</CurrentUserContext.Provider>;
}

export function useCurrentUser() {
  const value = useContext(CurrentUserContext);
  if (value?.user == null) {
    throw new Error("No user");
  }

  return { currentUser: value.user };
}
